export const hash = '524b6533-5234-11ec-920b-16b38c2c4059';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6LdjeDYcAAAAAIBkqkyJP37Ki4QdCflMC9kjCMe7';
export const apiUrl = `https://api-global.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://global-socket.encontrodigital.com.br/';
// export const apiSocket = 'http://localhost:8001';
//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://simposioensinonasaude.ufcspa.edu.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'IV Simpósio Internacional de Ensino na Saúde - UFCSPA';
export const logo = '/assets/evento/logo.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'IV Simpósio Internacional de Ensino na Saúde - UFCSPA';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const defaultTheme = {
  defaultBackground: 'rgb(58,128,79)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: '#fff',
    backgroundSticky: '#fff',
    backgroundMobile: 'rgb(58,128,79)',
    color: 'rgb(58, 128, 79)',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
